import type {
  GroupEdgeSettings,
  ProtocolEdgeType,
  TopologyGraphEdgeSettings,
  TopologyGraphPreset,
} from '@ipfabric/utils';
import { getLabels } from 'components/Graph/GraphSidePanel/helpers/getLabels';
import { isGroupSettings } from 'components/Graph/GraphState';
import { getGroupLabels } from 'components/Graph/helpers/getGroupLabels';
import type { EnabledLabels } from 'components/Graph/helpers/getProtocolLabels';
import { detailedDiff } from 'deep-object-diff';

export interface GraphEdgeSettingsLabelsVisibilityDiff {
  added: EnabledLabels;
  deleted: EnabledLabels;
  updated: EnabledLabels;
}

export const getLabelsVisibilityDiff = (
  currentEdge: TopologyGraphEdgeSettings,
  updatedEdge: TopologyGraphEdgeSettings,
  currentPreset: TopologyGraphPreset,
  updatedPreset: TopologyGraphPreset,
  groupId: GroupEdgeSettings['id'] | null,
  protocolName?: ProtocolEdgeType,
): GraphEdgeSettingsLabelsVisibilityDiff => {
  if (isGroupSettings(currentEdge) && isGroupSettings(updatedEdge)) {
    return detailedDiff(
      getGroupLabels(currentEdge),
      getGroupLabels(updatedEdge),
    ) as GraphEdgeSettingsLabelsVisibilityDiff;
  }
  const currentLabels = getLabels(currentPreset, groupId, protocolName);
  const updatedLabels = getLabels(updatedPreset, groupId, protocolName);

  return detailedDiff(
    { ...currentLabels.linecap, ...currentLabels.center },
    { ...updatedLabels.linecap, ...updatedLabels.center },
  ) as GraphEdgeSettingsLabelsVisibilityDiff;
};
